import React from "react";
import { Stack, Typography, TextField, Button } from "@mui/material";

import PacketTable from "../PacketTable/PacketTable";

import "./M3LogsColumns.scss";
import MarkerGuessTable from "../MarkerGuessTable/MarkerGuessTable";

const M3LogsColumns = ({
  packets,
  isDisable,
  GpsLogs = [],
  checkLocation,
  guessData = [],
  selectedPacket,
  handlePacketSelect,
  handleUpdateMarker,
  level = "intermediate",
}) => {
  function getCommand(packet) {
    if (!packet && level === "intermediate") {
      return '{"command":"**","parameter":""}';
    }
    if (!packet && level === "advanced") {
      return "command(** ** **)";
    }
    // For packets with encryptedCommand property
    if (packet.data) {
      // Remove commas from the encryptedCommand string

      return JSON.stringify(packet.data);
    }

    // Fallback to old format if no encryptedCommand available
    if (packet.data) {
      return JSON.stringify(packet.data);
    }

    return "N/A";
  }
  // Figure out what to display in the input's value
  let displayedValue = selectedPacket?.data
    ? JSON.stringify(selectedPacket.data)
    : getCommand(selectedPacket);

  const formatTimeOnly = (isoTimestamp) => {
    const date = new Date(isoTimestamp);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  return (
    <Stack className="logs-paper" useFlexGap gap={2}>
      <Stack useFlexGap gap={1}>
        <Stack className="timestamp-section">
          {GpsLogs.length > 0 ? (
            GpsLogs.map((log, index) => (
              <Stack
                direction="row"
                alignItems="center"
                spacing={2}
                key={index}
              >
                <Typography variant="subtitle2">
                  {formatTimeOnly(log.timestamp)}{" "}
                  {log.coordinates &&
                  typeof log.coordinates.lat === "number" &&
                  typeof log.coordinates.lng === "number"
                    ? `     ${log.coordinates.lat}     ${log.coordinates.lng}   ${log.coordinates.alt}`
                    : "..... ...."}
                </Typography>
              </Stack>
            ))
          ) : (
            <Typography variant="body2" color="textSecondary">
              No GPS logs available.
            </Typography>
          )}
        </Stack>

        <Stack useFlexGap={1} gap={1}>
          <PacketTable
            packets={packets}
            selectedPacket={selectedPacket}
            handlePacketSelect={handlePacketSelect}
          />

          <TextField
            aria-readonly
            variant="outlined"
            size="small"
            placeholder='{"command":"turn_clockwise","parameter":"45"}'
            value={displayedValue}
            slotProps={{
              input: {
                readOnly: true,
              },
            }}
          />
        </Stack>
      </Stack>

      <Stack className="input-check-section" useFlexGap gap={2}>
        <Stack height="120px" overflow="auto">
          {guessData.length > 0 && (
            <MarkerGuessTable
              guessData={guessData}
              handleEdit={handleUpdateMarker}
            />
          )}
        </Stack>
        <Stack className="wrapper">
          <Button
            variant="contained"
            className={`btn button  ${isDisable && "disabled"}`} //${isDisable && "disabled"}
            onClick={checkLocation}
            disabled={isDisable}
          >
            Check
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default M3LogsColumns;
